import { Program } from '~source/core/models/tv-guide';
import { isLiveProgram } from '~source/utils/is-live-program';

const isProgramFuture = (program: Program): boolean => {
    const now = new Date();
    const startDate = new Date(program.dateStart);
    return startDate.getTime() > now.getTime();
};

const isProgramReplay = (program: Program): boolean => {
    const now = new Date();
    const endDate = new Date(program.dateEnd);
    return endDate.getTime() < now.getTime();
};

export const buildEpgWebUrl = (program: Program): string | null => {
    // Future: no navigation
    if (isProgramFuture(program)) return null;

    // Live: go to channel live
    if (isLiveProgram(program)) {
        return `/live/${program.channelId}`;
    }

    if (program.serial) {
        const base = `/live/${program.channelId}/${encodeURIComponent(program.serial)}`;
        if (typeof program.event === 'number') {
            return `${base}/${encodeURIComponent(String(program.event))}`;
        }
        return base;
    }

    if (isProgramReplay(program)) {
        return `/live/${program.channelId}`;
    }

    return `/live/${program.channelId}`;
};

export const navigateToEpgWebUrl = (program: Program): void => {
    const href = buildEpgWebUrl(program);
    if (!href) return;
    window.location.href = href;
};
